module.exports = __webpack_public_path__ + "assets/img/answer_small.a195885e.svg";